import axios from 'axios';

export const SUPPORTED_COUNTRIES = {
  us: { name: 'USA', code: 'us', currency: 'usd', decimal: '.', separator: ',' },
  ca: { name: 'Canada', code: 'ca', currency: 'cad', decimal: '.', separator: ',' },
  au: { name: 'Australia', code: 'au', currency: 'aud', decimal: '.', separator: ',' },
  nz: { name: 'New Zealand', code: 'nz', currency: 'nzd', decimal: '.', separator: ',' },
  gb: { name: 'Great Britain', code: 'gb', currency: 'gbp', decimal: '.', separator: ',' },
  at: { name: 'Austria', code: 'at', currency: 'eur', decimal: ',', separator: '.' },
  be: { name: 'Belgium', code: 'be', currency: 'eur', decimal: ',', separator: '.' },
  fi: { name: 'Finland', code: 'fi', currency: 'eur', decimal: ',', separator: '.' },
  fr: { name: 'France', code: 'fr', currency: 'eur', decimal: ',', separator: '.' },
  de: { name: 'Germany', code: 'de', currency: 'eur', decimal: ',', separator: '.' },
  ie: { name: 'Ireland', code: 'ie', currency: 'eur', decimal: ',', separator: '.' },
  it: { name: 'Italy', code: 'it', currency: 'eur', decimal: ',', separator: '.' },
  lu: { name: 'Luxembourg', code: 'lu', currency: 'eur', decimal: ',', separator: '.' },
  mt: { name: 'Malta', code: 'mt', currency: 'eur', decimal: ',', separator: '.' },
  nl: { name: 'Netherlands', code: 'nl', currency: 'eur', decimal: ',', separator: '.' },
  pt: { name: 'Portugal', code: 'pt', currency: 'eur', decimal: ',', separator: '.' },
  si: { name: 'Slovenia', code: 'si', currency: 'eur', decimal: ',', separator: '.' },
  es: { name: 'Spain', code: 'es', currency: 'eur', decimal: ',', separator: '.' },
};

export const DEFAULT_COUNTRY = SUPPORTED_COUNTRIES.us;

export const SUPPORTED_CURRENCIES = {
  usd: { code: 'usd', precision: 2, zero: false, symbol: '$', decimal: '.', separator: ',' },
  cad: { code: 'cad', precision: 2, zero: false, symbol: '$', decimal: '.', separator: ',' },
  aud: { code: 'aud', precision: 2, zero: false, symbol: '$', decimal: '.', separator: ',' },
  nzd: { code: 'nzd', precision: 2, zero: false, symbol: '$', decimal: '.', separator: ',' },
  gbp: { code: 'gbp', precision: 2, zero: false, symbol: '£', decimal: '.', separator: ',' },
  eur: { code: 'eur', precision: 2, zero: false, symbol: '€', decimal: ',', separator: '.' },
};

(async () => {
  if (!process.env.BIG_DATA_CLOUD_API_KEY) {
    return;
  }
  try {
    const response = await axios.get(
      `https://api.bigdatacloud.net/data/country-by-ip?key=${process.env.BIG_DATA_CLOUD_API_KEY}`,
    );
    const countryCode = response?.data?.country?.isoAlpha2?.toLowerCase();
    const country = SUPPORTED_COUNTRIES[countryCode] || DEFAULT_COUNTRY;
    const currency = SUPPORTED_CURRENCIES[country.currency];

    const symbolEls = document.querySelectorAll('[data-currency-el="symbol"]');
    [...symbolEls].forEach(symbolEl => {
      // eslint-disable-next-line no-param-reassign
      symbolEl.innerHTML = currency.symbol;
    });
  } catch (error) {
    //
  }
})();
